import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  class: "avatar-container"
}
const _hoisted_3 = { class: "bottom-bar" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconAccountOffOutline = _resolveComponent("IconAccountOffOutline")
  const _component_NcLoadingIcon = _resolveComponent("NcLoadingIcon")
  const _component_VideoBackground = _resolveComponent("VideoBackground")
  const _component_AvatarWrapper = _resolveComponent("AvatarWrapper")
  const _component_NcButton = _resolveComponent("NcButton")

  return (_openBlock(), _createElementBlock("div", {
    ref: "videoContainer",
    class: _normalizeClass(["localVideoContainer", $options.videoContainerClass]),
    onMouseover: _cache[2] || (_cache[2] = $event => ($data.mouseover = true)),
    onMouseleave: _cache[3] || (_cache[3] = $event => ($data.mouseover = false)),
    onClick: _cache[4] || (_cache[4] = $event => (_ctx.$emit('clickVideo')))
  }, [
    ($options.screenshotModeUrl)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "dev-mode-video--self videoWrapper",
          alt: "dev-mode-video--self",
          src: $options.screenshotModeUrl
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", {
      class: "videoWrapper",
      style: _normalizeStyle($options.videoWrapperStyle)
    }, [
      _createElementVNode("video", {
        id: "localVideo",
        ref: "video",
        disablePictureInPicture: "true",
        class: _normalizeClass([$props.fitVideo ? 'video--fit' : 'video--fill', "video"]),
        onPlaying: _cache[0] || (_cache[0] = (...args) => ($options.updateVideoAspectRatio && $options.updateVideoAspectRatio(...args)))
      }, null, 34),
      ($props.isPresenterOverlay && $data.mouseover)
        ? (_openBlock(), _createBlock(_component_IconAccountOffOutline, {
            key: 0,
            class: "presenter-icon__hide",
            "aria-label": $options.t('spreed', 'Hide presenter video'),
            title: $options.t('spreed', 'Hide presenter video'),
            size: 32,
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('clickPresenter')))
          }, null, 8, ["aria-label", "title"]))
        : _createCommentVNode("", true),
      ($options.isNotConnected)
        ? (_openBlock(), _createBlock(_component_NcLoadingIcon, {
            key: 1,
            size: $options.avatarSize / 2,
            class: "video-loading"
          }, null, 8, ["size"]))
        : _createCommentVNode("", true)
    ], 4), [
      [_vShow, !$options.screenshotModeUrl && $props.localMediaModel.attributes.videoEnabled]
    ]),
    (!$options.screenshotModeUrl && !$props.localMediaModel.attributes.videoEnabled && !$props.isSidebar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          ($props.isGrid || $props.isStripe)
            ? (_openBlock(), _createBlock(_component_VideoBackground, {
                key: 0,
                "display-name": $options.displayName,
                user: $options.userId
              }, null, 8, ["display-name", "user"]))
            : _createCommentVNode("", true),
          _createVNode(_component_AvatarWrapper, {
            id: $options.userId,
            token: $props.token,
            name: $options.displayName,
            source: $setup.actorStore.actorType,
            size: $options.avatarSize,
            loading: $options.isNotConnected,
            "disable-menu": "",
            "disable-tooltip": ""
          }, null, 8, ["id", "token", "name", "source", "size", "loading"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      ($props.isBig)
        ? (_openBlock(), _createBlock(_component_NcButton, {
            key: 0,
            variant: "tertiary",
            class: "bottom-bar__button",
            onClick: $options.handleStopFollowing
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($options.stopFollowingLabel), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ])
  ], 34))
}